import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=08b359bf&scoped=true&"
import script from "./AddLocation.vue?vue&type=script&lang=ts&"
export * from "./AddLocation.vue?vue&type=script&lang=ts&"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=08b359bf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b359bf",
  null
  
)

export default component.exports